var irreducible = require('./irreducible');
var isType = require('./isType');

module.exports = irreducible('Type', isType);


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/Type.js
 ** module id = 97
 ** module chunks = 0
 **/